import * as Sentry from '@sentry/vue'
import type { App } from 'vue'

import { config } from '@/lib/helpers'
import router from '@/router'

export const errorHandler = {
  install: (app: App) => {
    window.onerror = function (event, source, line, column) {
      if (config.environment === 'production') {
        Sentry.captureException(
          new Error(
            `Event: ${typeof event === 'string' ? event : JSON.stringify(event)}, Source: ${source}. Line: ${line}. Column: ${column}`,
          ),
        )
      }
    }

    app.config.errorHandler = (err) => {
      Sentry.captureException(err)
      void router.push('/error')
      if (config.environment === 'local') {
        // eslint-disable-next-line no-console
        console.error(err)
      }
    }
  },
}
